import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d967aadc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d967aadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d967aadc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d967aadc')) {
      api.createRecord('d967aadc', component.options)
    } else {
      api.reload('d967aadc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d967aadc&scoped=true&", function () {
      api.rerender('d967aadc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/index.vue"
export default component.exports